import PropTypes from 'prop-types';
import warning from 'tiny-warning';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {
  textSize: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, '1', '2', '3', '4', '5', '6', '7']),
  align: deprecatedProp(PropTypes.oneOf(['standard', 'left', 'center', 'right']), 'Consider using core prop `textAlign` instead.'),
  allCaps: deprecatedProp(PropTypes.bool, 'Consider using core prop `textAllCaps` instead.'),
  weight: deprecatedProp(PropTypes.oneOf(['standard', 'bold', 'not-bold']), 'Consider using core prop `fontWeight` instead.'),
  overline: PropTypes.bool,
  noWrap: PropTypes.bool,
  truncate: PropTypes.bool
};
var propKeysToRemove = ['__dangerouslySuppressWarning', 'textSize', 'align', 'allCaps', 'weight', 'overline', 'noWrap', 'truncate'];
var textSizeToFontSizeMap = {
  '1': 6,
  '2': 5,
  '3': 4,
  '4': 3,
  '5': 2,
  '6': 1,
  '7': '-1'
};
var propWeightToFontWeight = {
  bold: 'bold',
  'not-bold': 'normal'
};
var headingToSizeMap = {
  h1: 6,
  h2: 5,
  h3: 4,
  h4: 3,
  h5: 2,
  h6: 1
};
var headingSizeToWeightMap = {
  h1: 'bold',
  h2: 'bold',
  h3: 'bold',
  h4: 'bold',
  h5: 'bold',
  h6: 'bold'
};
var derivedSizeToWeight = {
  6: 'bold',
  5: 'bold',
  4: 'bold'
};

function get(obj, key) {
  if (key === null || key === undefined || !obj) return undefined;

  if (key in obj) {
    return obj[key];
  }

  return undefined;
}

var Typography = createComponent({
  displayName: 'Typography',
  root: 'div',
  propTypes: propTypes,
  propKeysToRemove: propKeysToRemove,
  propConfig: {
    derivedProps: function derivedProps(props) {
      var fontSize = props.fontSize,
          fontWeight = props.fontWeight,
          weight = props.weight,
          textSize = props.textSize,
          as = props.as,
          component = props.component,
          __dangerouslySuppressWarning = props.__dangerouslySuppressWarning;
      var tag = as || component;
      var derivedFontSize = get(textSizeToFontSizeMap, textSize) || get(headingToSizeMap, tag) || undefined;

      if (typeof tag === 'string' && tag in headingSizeToWeightMap) {
        warning(__dangerouslySuppressWarning, "Typography rendered as ".concat(tag, ": Consider using SWAN's heading component <").concat(tag.toUpperCase(), ">"));
      }

      return {
        fontSize: fontSize || derivedFontSize,
        fontWeight: fontWeight || get(headingSizeToWeightMap, tag) || get(derivedSizeToWeight, derivedFontSize) || get(propWeightToFontWeight, weight)
      };
    },
    processProps: function processProps(props, derivedProps) {
      return _object_spread({}, derivedProps, props);
    },
    classNames: function classNames(props) {
      var classNameSet = new Set();
      var align = props.align,
          allCaps = props.allCaps,
          overline = props.overline,
          noWrap = props.noWrap,
          truncate = props.truncate,
          as = props.as,
          component = props.component;
      var tag = as || component;
      if (typeof tag === 'string' && tag in headingSizeToWeightMap) classNameSet.add('swan-heading');
      if (align && align !== 'standard') classNameSet.add("swan-text-".concat(align));
      if (allCaps) classNameSet.add("swan-text-all-caps");
      if (overline) classNameSet.add("swan-text-overline");
      if (noWrap) classNameSet.add("swan-text-no-wrap");
      if (truncate) classNameSet.add("swan-text-truncate");
      return classNameSet;
    }
  }
});
export { Typography };